export const applePayButtonTypes = {
  PLAIN: 'plain',
  BUY: 'buy',
  ADD_MONEY: 'addMoney',
  BOOK: 'book',
  CHECKOUT: 'checkout',
  CONTINUE: 'continue',
  CONTRIBUTE: 'contribute',
  DONATE: 'donate',
  IN_STORE: 'inStore',
  ORDER: 'order',
  RELOAD: 'reload',
  RENT: 'rent',
  SET_UP: 'setUp',
  SUBSCRIBE: 'subscribe',
  SUPPORT: 'support',
  TIP: 'tip',
  TOP_UP: 'topUp',
} as const;

export type ApplePayButtonTypes = (typeof applePayButtonTypes)[keyof typeof applePayButtonTypes];
